import { Form, Table, Input, Button, message, Flex, TableProps, TableColumnsType, Empty, Tooltip, Checkbox, CheckboxProps } from "antd";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CheckCircleFilled, CopyOutlined, LoadingOutlined, CloseCircleFilled, Loading3QuartersOutlined } from '@ant-design/icons';
import { filterNotNumber, formatNumber, strDot, sum, toThousands } from "@/utils";
import TransactionTag from "../TransactionTag";
import MultiState from "@/pages/BatchSwap/components/MultiState";
import "./index.less"
import { cdnUrl } from '@/utils/cdn';
import SecurityNoticeModal from "@/components/SecurityNoticeModal";


import { DataType } from "../../interface";
import Loader from "@/components/Loader";
import { getSymbol } from "@/config/symbol";
import { getDexs } from "@/config/swap";

const { stableCoins } = getDexs()

type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection'];

export default function WalletAddressPanel({
  otherTokenInfo,
  // selectedTokenInfo,
  wallets,
  executionTimes,
  isLoopExecution,
  queryWalletsCurrentBalance,
  listLoading,
  progress,
  openUploadModal,
  onDeleteIem,
  onDelWallet,
  selectedRowKeys,
  setSelectedRowKeys,
  postAccountOverview,
  usdcAddress,
  bnbAddress,
  tokenAInfo,
  tokenBInfo
}: any) {
  const { t } = useTranslation();
  const [queryLoading, setQueryLoading] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();
  const securityNoticeModalRef = useRef<any>(null)

  function onCopy() {
    messageApi.success(t("tips.copy"));
  }

  function handleEmpty(list: any = [], num: any) {
    if (list.length === 0) {
      return '-';
    }
    return toThousands(filterNotNumber(num, 4));
  }

  function setAccountOverview() {
    console.log("改变")
    const res = {
      accountOverview: {
        addressCount: handleEmpty(wallets, wallets.length),
        balance: handleEmpty(wallets,
          wallets.reduce((sum: any, item: any) => sum + Number(item.balance), 0)
        ),
        tokenABalance: handleEmpty(wallets,
          wallets.reduce((sum: any, item: any) => sum + Number(item.tokenABalance), 0)
        ),
        selectedTokenABalance: handleEmpty(wallets,
          wallets.reduce((sum: any, item: any) => sum + Number(item.tokenABalance), 0)
        ),
        tokenBBalance: handleEmpty(wallets,
          wallets.reduce((sum: any, item: any) => sum + Number(item.tokenBBalance), 0)
        ),
        selectedTokenBBalance: handleEmpty(wallets,
          wallets.reduce((sum: any, item: any) => sum + Number(item.tokenBBalance), 0)
        )
      },
      selectedAccountOverview: {
        addressCount: handleEmpty(selectedRowKeys, selectedRowKeys.length),
        balance: handleEmpty(selectedRowKeys,
          wallets
            .filter((item: any) => selectedRowKeys.includes(item.key))
            .reduce((sum: any, item: any) => sum + Number(item.balance), 0)
        ),
        tokenABalance: handleEmpty(selectedRowKeys,
          wallets
            .filter((item: any) => selectedRowKeys.includes(item.key))
            .reduce((sum: any, item: any) => sum + Number(item.tokenABalance), 0)
        ),
        selectedTokenABalance: handleEmpty(selectedRowKeys,
          wallets
            .filter((item: any) => selectedRowKeys.includes(item.key))
            .reduce((sum: any, item: any) => sum + Number(item.tokenABalance), 0)
        ),
        tokenBBalance: handleEmpty(selectedRowKeys,
          wallets
            .filter((item: any) => selectedRowKeys.includes(item.key))
            .reduce((sum: any, item: any) => sum + Number(item.tokenBBalance), 0)
        ),
        selectedTokenBBalance: handleEmpty(selectedRowKeys,
          wallets
            .filter((item: any) => selectedRowKeys.includes(item.key))
            .reduce((sum: any, item: any) => sum + Number(item.tokenBBalance), 0)
        )
      }
    };
    postAccountOverview && postAccountOverview(res);
  }

  useEffect(() => {
    setAccountOverview();

    // filterSelectedItem();
  }, [selectedRowKeys, wallets]);

  function switchStatus(row: any) {
    if (Number(row.status) === 0) {
      return <TransactionTag status={"noStart"} txt={t("batchTransfer.notExecuted")} />;
    }
    if (isLoopExecution) {
      return <MultiState wallet={row} executionTimes={executionTimes} />;
    } else {
      if (Number(row.status) === 1) {
        return <TransactionTag status={"loading"} txt="" />;
      }
      if (Number(row.status) === 2) {
        return <TransactionTag status={"success"} txt={t("batchTransfer.success")} hash={row.tx} onCopy={() => { onCopy() }} />;
      }

      if (Number(row.status) === 3) {
        return <TransactionTag status={"fail"} txt={row.msg} hash={row.tx} onCopy={() => { onCopy() }} />;
      }
      if (Number(row.status) === 4) {
        return <TransactionTag status={"success1"} txt={t("batchTransfer.success")} />;
      }
    }

  }

  const columns: TableColumnsType<any> = [
    {
      title: '#',
      dataIndex: 'key',
      key: 'key',
      align: 'center',
      width: 60,

      render: (_, record, index) => (
        <div className="custom-td">
          <p>{index + 1}</p>
        </div>
      )
    },
    {
      title: t("tokenBatchCollection.walletAddress"),
      dataIndex: 'walletAddress',
      key: 'walletAddress',
      align: 'center',
      render: (_, record) => (
        <CopyToClipboard text={`${record.walletAddress}`} onCopy={() => { onCopy() }}>
          <div className="custom-td" style={{ cursor: "pointer" }}>
            <p style={{ marginRight: '5px' }}>{strDot(record.walletAddress)}</p>
            <CopyOutlined style={{ color: '#bababa' }} />
          </div>
        </CopyToClipboard>
      )
    },
    {
      title: t("tokenBatchCollection.nativeTokenBalance", { symbol: getSymbol() }),
      dataIndex: 'balance',
      key: 'balance',
      align: 'center',
      render: (_, record) => (
        <div className="custom-td">
          <p>{`${formatNumber(record.balance, 4)}`}</p>
        </div>
      )
    },
    {
      title: t("tokenBatchCollection.tokenBalance", { symbol: tokenAInfo.symbol }),
      dataIndex: 'tokenABalance',
      key: 'tokenABalance',
      align: 'center',
      hidden: tokenAInfo.coinType == "0x2::sui::SUI",
      render: (_, record) => (
        <div className="custom-td">
          <p>{`${formatNumber(record.tokenABalance, 4)}`}</p>
        </div>
      )
    },
    {
      title: t("tokenBatchCollection.tokenBalance", {
        symbol: tokenBInfo.symbol
      }),
      dataIndex: 'tokenBBalance',
      key: 'tokenBBalance',
      align: 'center',
      hidden: tokenBInfo.coinType == "0x2::sui::SUI",
      render: (_, record) => (
        <div className="custom-td">
          <p>{otherTokenInfo && ![usdcAddress, bnbAddress].includes(otherTokenInfo.address) ? `${formatNumber(record.tokenBBalance, 4)}` : "--"}</p>
        </div>
      )
    },
    {
      title: t("tokenBatchCollection.status"),
      key: 'status',
      align: 'center',
      render: (_, record) => (
        <div className="custom-td">{switchStatus(record)}</div>
      )
    },
    {
      title: t("tokenBatchCollection.operation"),
      key: 'operation',
      align: 'center',
      width: 100,
      render: (row: any) => (
        <div className="custom-td">
          <img style={{ cursor: "pointer" }} src={cdnUrl("/img/delete.svg")} onClick={() => onDeleteIem(row)} />
        </div>
      )
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log("newSelectedRowKeys", newSelectedRowKeys); // 打印新的选中行 keys
    setSelectedRowKeys(newSelectedRowKeys); // 更新选中的行 keys
  };

  const rowSelection: TableRowSelection<DataType> = {
    selectedRowKeys,
    onChange: onSelectChange,
    columnWidth: 50,
  };

  async function queryBalance() {
    setQueryLoading(true);
    try {
      await queryWalletsCurrentBalance();
      setQueryLoading(false);
    } catch (error) {
      console.log('更新代币余额error', error);
      setQueryLoading(false);
      throw error;
    }
  }
  console.log("walletss", wallets)
  const selectBalanceZero = () => {
    const selectedKeys = wallets
      .filter((record: any) => record.tokenBBalanceWei == "0")
      .map((record: any) => record.key);
    console.log("selectedKeys", selectedKeys)
    setSelectedRowKeys(selectedKeys);
  };

  const selectBalanceGreaterThanZero = () => {
    const selectedKeys = wallets
      .filter((record: any) => record.tokenBBalanceWei > 0)
      .map((record: any) => record.key);
    setSelectedRowKeys(selectedKeys);
  };

  const selectFailed = () => {
    const selectedKeys = wallets.filter((record: any) => record.status === 3).map((record: any) => record.key);
    setSelectedRowKeys(selectedKeys);
  };

  const selectInverse = () => {
    const selectedKeys = wallets
      .filter((record: any) => !selectedRowKeys.includes(record.key))
      .map((record: any) => record.key);
    setSelectedRowKeys(selectedKeys);
  };

  const delSelect = () => {
    const newWallets = wallets.filter((item: any) => !selectedRowKeys.includes(item.key));
    setSelectedRowKeys([]);
    if (onDelWallet) {
      onDelWallet(newWallets);
    }
    setQueryLoading(false);
  };
  const onOpenUploadModal = () => {
    securityNoticeModalRef.current?.showModal({
      source: "batchSwap",
      cb: () => {
        openUploadModal();
      }
    });
  }

  return (
    <>
      {contextHolder}
      <div className="wallet-address-panel">
        <div className="btns">
          <div className="sub">
            <Button type="primary" onClick={onOpenUploadModal} className="import-btn">
              {t("batchSwap.importWallet")}
            </Button>
            <Button
              onClick={queryBalance}
              disabled={wallets.length === 0}
              className="query-btn"
              icon={queryLoading
                ?
                <Loader>
                  <img style={{ width: "20px" }} src={cdnUrl("/img/loading-grey.webp")} alt="" />
                </Loader>
                :
                ""
              }
            >
              {t("tokenBatchCollection.queryBalance")}
            </Button>
          </div>
          {wallets.length > 0 && (
            <div className='shortcut-button'>
              <Button type='default' onClick={selectBalanceZero}>
                {t("batchSwap.selectZeroBalance")}
              </Button>
              <Button type='default' onClick={selectBalanceGreaterThanZero}>
                {t("batchSwap.selectBalanceGreaterThanZero")}
              </Button>
              <Button type='default' onClick={selectInverse}>
                {t("batchSwap.invertSelection")}
              </Button>
              <Button type='default' onClick={selectFailed}>
                {t("batchSwap.selectionFailed")}
              </Button>
              <Button type='default' icon={<img style={{ cursor: "pointer", width: "20px" }} src={cdnUrl("/img/delete.svg")} />} onClick={() => delSelect()}>
              </Button>
            </div>
          )}
        </div>
        <div className="table">
          {
            listLoading ? (
              <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Loader>
                  <img style={{ width: "20px" }} src={cdnUrl("/img/loading-grey.webp")} alt="" />
                </Loader>
                <span> {t("tokenBatchCollection.importing")} {progress.toFixed()}%</span>
              </div>
            ) : wallets.length === 0 ? (
              <Flex vertical justify="center" align="center" className="empty">
                <img src={cdnUrl("/img/empty.svg")} alt="" />
                <span>{t("tokenBatchCollection.importWalletPrivateKey")}</span>
              </Flex>
            ) : (
              <Table<any>
                virtual
                rowSelection={rowSelection}
                columns={columns}
                dataSource={wallets}
                pagination={false}
                scroll={{ y: 375, x: 976 }}
              />
            )
          }
        </div>
      </div>
      <SecurityNoticeModal ref={securityNoticeModalRef} />
    </>
  )
}